import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig"
import * as Yup from "yup"
let moduleConfig = {}
moduleConfig = {
    ...moduleDefaultConfig
};

moduleConfig.hasStatusSearch = false;

moduleConfig.title = 'Contact Us OSMA Submissions';
moduleConfig.singleItemTitle = 'Contact Us OSMA';
moduleConfig.url = 'osma-contact-us';

moduleConfig.buttons = {
    create: false,
    view: true,
    update: false,
    delete: true,
};

moduleConfig.bulkActions = [

    {
        displayName: "Delete Selected",
        value: "Delete"
    }
]

moduleConfig.fields = [
    {
        displayName: "ID",
        fieldName: "_id",
        type: "text",
        control: "hidden",
    },
    {
        displayName: "First Name",
        fieldName: "firstName",
        type: "text",
        control: "input",
        showOnListing: true,
        sortable: true,
    },
    {
        displayName: "Last Name",
        fieldName: "lastName",
        type: "text",
        control: "input",
        showOnListing: true,
        sortable: true,
    },
    {
        displayName: "Email",
        fieldName: "email",
        type: "email",
        control: "input",
        showOnListing: true,
        sortable: true,
    },
    {
        displayName: "Mobile",
        fieldName: "mobile",
        type: "text",
        control: "input",
        showOnListing: true,
        sortable: true,
        displayStyle: "phone"
    },
    {
        displayName: "Company",
        fieldName: "company",
        type: "text",
        control: "input",
        showOnListing: true,
    },
    {
        displayName: "Designation",
        fieldName: "designation",
        type: "text",
        control: "input",
        showOnListing: true,
    },
    {
        displayName: "Message",
        fieldName: "message",
        type: "text",
        control: "input",
    },
    {
        displayName: "Submission Date/Time",
        fieldName: "createdAt",
        type: "dateTime",
    },
];
moduleConfig.initialValues = {

}
moduleConfig.validationSchema = Yup.object({

})

export default moduleConfig;